import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter4() {
  const hyperlinkData = [
    {
      href: 'https://northernlightsyukon.com/',
      copy: 'Northern Lights Resort & Spa',
      label: 'Visit Northern Lights Resort & Spa Homepage'
    },
    {
      href: 'https://eclipsenordichotsprings.ca/',
      copy: 'Eclipse Nordic Hot Springs',
      label: 'Visit Eclipse Nordic Hot Springs Homepage'
    },
    {
      href: 'https://bontonandco.ca/',
      copy: 'BonTon & Company',
      label: 'Visit BonTon & Company Homepage'
    },
    {
      href: 'https://2021.canadasbestnewrestaurants.com/en/',
      copy: 'Canada’s best new restaurants',
      label: 'Visit Canada’s Best New Restaurants 2021'
    },
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/british-columbia/',
      copy: 'adaptive advocate Wesley Hamilton recently experienced in our film',
      label: 'Visit Episode Three, Explore British Columbia with Wesley Hamilton'
    }
  ];
  return (
    <section className="chapter">
      <h2 className="chapter__head">Yukon</h2>
      <h3 className="chapter__subhead">In search of wellness and restoration</h3>
      <p className="chapter__paragraph">
        Once a hot spot for the Klondike gold rush in the late 1890s, Yukon is also known for its
        natural beauty and remains largely covered in wilderness. With its pulsing rivers, winding
        trails, and views of the tallest mountain in Canada, Mount Logan, this larger-than-life
        territory is the perfect place to rediscover what it means to unplug and relax.
      </p>
      <p className="chapter__paragraph">
        British Columbia and Alberta might be the most well-known hubs of adventure tourism in
        Canada (like <Hyperlink hyperlinkData={hyperlinkData[4]} />
        ), but intrepid travelers can also head north to Yukon for a unique wellness retreat. The
        rugged terrain of Yukon affords countless opportunities to spot moose, stargaze, and witness
        the famous northern lights. View the celestial night show from a glass chalet at{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} /> in the capital, Whitehorse. (The prime
        viewing window is mid-August to mid-April.) The morning after, enjoy forest bathing in the
        Southern Lakes region and embark on your self-care journey with a yoga class at{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />. Head even further north for more chances to
        downshift, starting with a leisurely hike (or, in the winter, a snowshoeing jaunt) through
        Tombstone Territorial Park on the Dempster Highway, less than 200 miles from the Arctic
        Circle. This park lies within traditional Tr’ondëk Hwëch’in territory and features 78
        protected ecological sites. In nearby Dawson City, savor regional tapas and craft beer in{' '}
        <Hyperlink hyperlinkData={hyperlinkData[2]} />
        ’s rustic log cabin, named one of <Hyperlink hyperlinkData={hyperlinkData[3]} />
        —and a perfect place to pause to reflect and relax.
      </p>
    </section>
  );
}

export default Chapter4;
